<template>
  <OverlayRight
    ref="overlayRef"
    view="medium"
    @overlay-right-open="emit('open-overlay-right')"
    @overlay-right-closed="close"
  >
    <template #header>
      <h5>{{ overlayTitle }}</h5>
    </template>
    <template #content>
      <b-container class="mt-4">
        <b-row>
          <b-col md="4">
            <b-button
              size="sm"
              @click="emit('archive-one-day-vacancy')"
            >
              {{ $gadTranslate('general_archive') }}
            </b-button>
          </b-col>
          <b-col md="4">
            <b-button
              size="sm"
              @click="emit('duplicate-one-day-vacancy')"
            >
              {{ $gadTranslate('general_duplicate') }}
            </b-button>
          </b-col>
          <b-col md="4">
            <b-button
              size="sm"
              @click="emit('delete-one-day-vacancy')"
            >
              {{ $gadTranslate('general_delete') }}
            </b-button>
          </b-col>
        </b-row>
        <TextOnLine
          class="mt-4 mb-4"
        >
          {{ $gadTranslate('general_or') }}
        </TextOnLine>
        <OneDayVacancyForm
          v-if="oneDayVacancyId && overlayIsOpen"
          :one-day-vacancy-id="oneDayVacancyId"
          :creating-new="creatingNew"
          @form-submitted="oneDayVacancyFormSubmitted"
        />
      </b-container>
    </template>
  </OverlayRight>
</template>

<script setup>
import { ref, computed } from 'vue'
import OverlayRight from '~/components/site-layout/overlay/OverlayRight.vue'
import OneDayVacancyForm from '~/components/form/OneDayVacancyForm.vue'
import TextOnLine from '~/components/text/TextOnLine.vue'

const props = defineProps({
  oneDayVacancyId: { type: Number, required: true },
})

const emit = defineEmits([
  'extend-one-day-vacancy',
  'archive-one-day-vacancy',
  'duplicate-one-day-vacancy',
  'delete-one-day-vacancy',
  'close-overlay-right',
  'open-overlay-right',
  'one-day-vacancy-form-submitted',
])

const nuxtApp = useNuxtApp()
const overlayRef = ref(null)
const creatingNew = ref(false)
const overlayIsOpen = ref(false)

const overlayTitle = computed(() => {
  const key = creatingNew.value ? 'general_create_one_day_vacancy' : 'general_modify'
  return nuxtApp.$gadTranslateUpper(key)
})

const oneDayVacancyFormSubmitted = (info) => {
  emit('one-day-vacancy-form-submitted', info)
  overlayRef.value?.close()
}

const close = () => {
  emit('close-overlay-right')
  overlayIsOpen.value = false
}

const open = (creatingNewParam) => {
  creatingNew.value = creatingNewParam
  overlayIsOpen.value = true
  overlayRef.value?.open()
}

defineExpose({
  open,
})
</script>

<style lang="scss" scoped>

</style>
